import {View} from '@ab/components';
import tpl from './templates/interactive.jsx';
import {connect} from 'react-redux';
import {showLogout} from '../../actions';

class Header extends View {
    template = tpl;

    state = {
        showMoreServices: false,
    };

    toggleMoreServices = () => {
        return this.setState({showMoreServices: !this.state.showMoreServices});
    };

    _handleMoreServicesEnter = () => {
        this.setState({showMoreServices: true});
    };

    _handleMoreServicesLeave = () => {
        this.setState({showMoreServices: false});
    };

    _handleMoreServicesClick = () => {
        this.toggleMoreServices();
    };

    static displayName = 'Header';
}

export default connect()(Header);
